export default __webpack_public_path__ + "static/media/logo_charitylabs.704a03cf.webp";